// OneDrive:IgnoreCodeCoverage
import * as React from 'react';
import {
    ShowMalwareDetectedAction as BaseShowMalwareDetectedAction,
    ItemShowMalwareDetectedAction as BaseItemShowMalwareDetectedAction,
    IItemShowMalwareDetectedActionProps as IBaseItemShowMalwareDetectedActionProps,
    IShowMalwareDetectedActionProps as IBaseShowMalwareDetectedActionProps
} from '../../base/actions/showMalwareDetected/ShowMalwareDetectedAction';
import { MalwareDetectedDialog } from './MalwareDetectedDialog';
import { IDecoratedProps } from '../../../utilities/components/Decorators';
import { IMalwareDetectedWizardProps } from '../../../controls/malwareDetectedControl';
import { injectInitialProps } from '../../../utilities/components/Props';

class MalwareDetectedWizard extends React.PureComponent<IMalwareDetectedWizardProps> {
    public render(): JSX.Element {
        const {
            itemKey,
            resolve,
            reject
        } = this.props;

        return (
            <MalwareDetectedDialog
                itemKey={ itemKey }
                resolve={ resolve }
                reject={ reject }
            />
        );
    }
}

function injectMalwareDetectedWizard(): Pick<IBaseItemShowMalwareDetectedActionProps, 'malwareDetectedWizard'> {
    return {
        malwareDetectedWizard: MalwareDetectedWizard
    };
}

export type IItemShowMalwareDetectedActionProps =
    IDecoratedProps<IBaseItemShowMalwareDetectedActionProps, Pick<IBaseItemShowMalwareDetectedActionProps, 'malwareDetectedWizard'>, {}>;

export const ItemShowMalwareDetectedAction: React.ComponentType<IItemShowMalwareDetectedActionProps> =
    injectInitialProps(injectMalwareDetectedWizard)(BaseItemShowMalwareDetectedAction);

export type IShowMalwareDetectedActionProps =
    IDecoratedProps<IBaseShowMalwareDetectedActionProps, Pick<IBaseShowMalwareDetectedActionProps, 'malwareDetectedWizard'>, {}>;

export const ShowMalwareDetectedAction: React.ComponentType<IShowMalwareDetectedActionProps> =
    injectInitialProps(injectMalwareDetectedWizard)(BaseShowMalwareDetectedAction);
